import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import type { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { Toaster as Sonner, type ToasterProps, toast } from 'sonner';

/**
 * Toast outlet; mount once near the root. Call `toast.success(...)` / `toast.error(...)` for
 * mutation results. Light theme only, styled from the popover tokens.
 */
function Toaster(props: ToasterProps) {
  const { t } = useTranslation();
  return (
    <Sonner
      theme="light"
      position="bottom-right"
      containerAriaLabel={t('notifications')}
      icons={{
        success: <CircleCheckIcon className="size-4 text-status-success" aria-hidden="true" />,
        info: <InfoIcon className="size-4 text-status-info" aria-hidden="true" />,
        warning: <TriangleAlertIcon className="size-4 text-status-warning" aria-hidden="true" />,
        error: <OctagonXIcon className="size-4 text-status-danger" aria-hidden="true" />,
        loading: <Loader2Icon className="size-4 motion-safe:animate-spin" aria-hidden="true" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius-lg)',
        } as CSSProperties
      }
      toastOptions={{
        classNames: { toast: 'font-sans shadow-overlay', title: 'font-bold text-heading' },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
